import { useContext, createContext, useState } from 'react';
import { useApiKey } from 'app/domains/api-management';
import { useCompanyFeatures } from 'app/domains/companies';
import { useFeatureFlag } from 'shared/domains/featureFlag';
const ApiProviderContext = createContext(undefined);
export const useApi = () => {
    const context = useContext(ApiProviderContext);
    if (!context) {
        throw new Error('useApi must be used within an ApiProvider');
    }
    return context;
};
function FlaggedApiProvider(props) {
    const { children } = props;
    const [dialog, setDialog] = useState(undefined);
    const apiKey = useApiKey(dialog === null || dialog === void 0 ? void 0 : dialog.id);
    return (<ApiProviderContext.Provider value={{
            dialog,
            setDialog,
            apiKey,
        }}>
      {children}
    </ApiProviderContext.Provider>);
}
export function ApiProvider(props) {
    const { children } = props;
    const { isFeatureAvailable } = useCompanyFeatures();
    const useApiManagement = isFeatureAvailable('web_api');
    const flagged = useFeatureFlag('feature_api_key_management');
    const apiAccess = useApiManagement && flagged;
    if (apiAccess) {
        return <FlaggedApiProvider>{children}</FlaggedApiProvider>;
    }
    return children;
}
